import React from "react";

import Modal from "@components/atoms/Modal";
import { useTranslation } from "react-i18next";
import CoachOverlayScreen from "@scenes/more/CoachOverlay";

const CoachOverlayModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingBottom={0}
      paddingTop={0}
      headerTitle={t("navigation.profile.general.label.coachOverlay")}
    >
      <CoachOverlayScreen modalPadding="0" />
    </Modal>
  );
};

export default CoachOverlayModal;
